<app-sidebar></app-sidebar>
<app-settings-component></app-settings-component>